import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from "react-router-dom";
import { CurrencyForm } from "../tabs/CurrencyForm";
import { DetailsForm } from "../tabs/DetailsForm";
import { TermsForm } from "../tabs/TermsForm";
import { SettingsForm } from "../tabs/SettingsForm";
import { ChargesForm } from "../tabs/ChargesForm";
import tabList from "../tabs/tabList.json";
import { AccountingForm } from "../tabs/AccountingForm";
import RecordStatus from "../../../../components/RecordStatus";
import CustomButton from '../../RetailLoan/editLoanProduct/customButton'
import { Card, Form, Spin } from 'antd';
import { InterestRateChart } from '../tabs/InterestRateForm';


const FixedDepositTabs = (props) => {

    const {
        interestRateTableSource,
        chargeDataSource,
    } = props;

    const navigate = useNavigate();
    const [activeTabKey, setActiveTabKey] = useState("details");
    const [loading, setLoading] = useState(true);

    const onTabChange = (key) => {
        setActiveTabKey(key);
    };

    useEffect(() => {
        // Simulate an API call or data fetching
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

    function onCancel() {
        navigate("/prd0200", { replace: false });
    }

    const contentListNoTitle = {
        details: (<>
            <DetailsForm
                disabled={props.disabled}
                onEditCancel={props.onEditCancel}
                formButtonState={props.formButtonState}
                fixedDepositDetails={props.fixedDepositDetails}
            />
            {!props.formButtonState && <CustomButton onCancel={onCancel} />}
        </>
        ),
        currency: (
            <>
                <CurrencyForm
                    disabled={props.disabled}
                    onEditCancel={props.onEditCancel}
                    formButtonState={props.formButtonState}
                    fixedDepositDetails={props.fixedDepositDetails}

                />
                {!props.formButtonState && <CustomButton onCancel={onCancel} />}
            </>
        ),
        terms: (
            <>
                <TermsForm
                    disabled={props.disabled}
                    onEditCancel={props.onEditCancel}
                    formButtonState={props.formButtonState}
                    fixedDepositDetails={props.fixedDepositDetails}

                />
                {!props.formButtonState && <CustomButton onCancel={onCancel} />}
            </>
        ),
        settings: (
            <>
                <SettingsForm
                    disabled={props.disabled}
                    onEditCancel={props.onEditCancel}
                    formButtonState={props.formButtonState}
                    fixedDepositDetails={props.fixedDepositDetails}

                />
                {!props.formButtonState && <CustomButton onCancel={onCancel} />}

            </>
        ),
        interestRateChart: (
            <>
                <InterestRateChart
                    disabled={props.disabled}
                    interestRateTableSource={interestRateTableSource}
                    onEditCancel={props.onEditCancel}
                    formButtonState={props.formButtonState}
                    fixedDepositDetails={props.fixedDepositDetails}

                />
                {!props.formButtonState && <CustomButton onCancel={onCancel} />}

            </>
        ),
        charges: (
            <>
                <ChargesForm
                    disabled={props.disabled}
                    onEditCancel={props.onEditCancel}
                    formButtonState={props.formButtonState}
                    fixedDepositDetails={props.fixedDepositDetails}
                    chargeDataSource={chargeDataSource}

                />
                {!props.formButtonState && <CustomButton onCancel={onCancel} />}

            </>
        ),
        accounting: (
            <>
                <AccountingForm
                    disabled={props.disabled}
                    onEditCancel={props.onEditCancel}
                    formButtonState={props.formButtonState}
                    fixedDepositDetails={props.fixedDepositDetails}

                />
                {!props.formButtonState && <CustomButton onCancel={onCancel} />}
            </>
        )
    };

    return (
        <Spin spinning={loading} size="large">
            <Card
                style={{
                    width: "100%",
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                    marginBottom: 50,
                }}
                tabList={tabList}
                activeTabKey={activeTabKey}
                onTabChange={onTabChange}
                tabProps={{
                    size: "middle",
                }}
            >
                <Form layout="vertical" style={{ margin: 30 }} >
                    {contentListNoTitle[activeTabKey]}
                </Form>
            </Card>
        </Spin>
    );
}

export default FixedDepositTabs